import React, { Component } from 'react';
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import DataTable from 'react-data-table-component';
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import cssu
import { tokenVerification } from './Utils';

class PainDataSchedule extends Component {
    constructor(props) {
        super(props);

        this.state = {
            startLoader: false,
            healthSystemId: '',
            hospitalId: '',
            serviceLineId: '',
            value: [],
            procedureData: '',
            loadedData: [],
            disableAddButton: false,
            editedId: '-1',
            editImageSrc: './assets/images/edit.svg',
            contentEditable: "false",
            hidden: false,
            hideDeletePopup: false,
            hideDeleteSuccessPopup: false,
            pageNum: null,
            paginationValue: 10,
            episodeName: "",
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.loadedWhenInfo = [];
        this.loadedAgentSkills = [];
        this.loadedNumberOfDaysInfo = [];
        window.patientEpisodeController = this;
    }

    componentDidMount() {
        this.loadPatientEpisodeData();
        localStorage.setItem("active-tab-of-manage-admission", "episodes");
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    loadPatientEpisodeData() {
        this.fetchIntentNamesApi();
        this.fetchWhenData();
        this.fetchNumberOfDays();

        // this.refreshData();
    }

    addEmptyRow = () => {
        console.log("Adding Empty Row");
        var thisController = this;
        thisController.state.paginationValue = thisController.state.paginationValue + 5;
        if (thisController.state.pageNum != 0) {
            thisController.setState({ pageNum: 0 })
        }
        thisController.state.loadedData.unshift({
            id: "",
            name: "",
        });
        thisController.state.disableAddButton = true;
        thisController.setState(thisController.state);

    }
    fetchNumberOfDays() {
        var fetchDataContoller = this;
        var responseData = []
        $.ajax(
            {
                url: "/my-jeeva-api/number-of-days",

                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        fetchDataContoller.state.showLoader = true;
                        fetchDataContoller.setState(fetchDataContoller.state);
                        var response = res.result;
                        var length = response.length;
                        fetchDataContoller.loadedNumberOfDaysInfo = [];


                        for (var i = 0; i < length; i++) {

                            fetchDataContoller.loadedNumberOfDaysInfo[i] = (response[i]);

                        }


                    } else {
                        fetchDataContoller.notifyFailedLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    fetchWhenData() {
        var fetchDataContoller = this;
        var responseData = []
        $.ajax(
            {
                url: "/my-jeeva-api/when-data",

                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                success: function (res) {
                    if (res.success === true) {
                        fetchDataContoller.state.showLoader = true;
                        fetchDataContoller.setState(fetchDataContoller.state);
                        var response = res.result;
                        var length = response.length;
                        fetchDataContoller.loadedWhenInfo = [];


                        for (var i = 0; i < length; i++) {

                            fetchDataContoller.loadedWhenInfo[i] = (response[i]);

                        }

                    } else {
                        fetchDataContoller.notifyFailedLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    fetchIntentNamesApi() {
        var episodeContoller = this;
        var responseData = [];
        episodeContoller.intentMap = {};

        $.ajax(
            {
                url: "/my-jeeva-api/agent-skills",

                method: 'GET',
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token")
                },
                data: {
                    treatmentId: localStorage.getItem("selectedTreatmentId")
                },
                success: function (res) {
                    if (res.success === true) {
                        episodeContoller.state.showLoader = true;
                        episodeContoller.setState(episodeContoller.state);
                        var response = res.result;
                        var length = response.length;
                        episodeContoller.loadedAgentSkills = [];

                        for (var i = 0; i < length; i++) {

                            episodeContoller.loadedAgentSkills[i] = (response[i]);
                            episodeContoller.intentMap[response[i].id] = response[i].description;
                        }
                        episodeContoller.fetchEpisodeDataApi();

                    } else {
                        // episodeContoller.notifyFailedLoad(res.result);
                        episodeContoller.notifyNoAgent();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        tokenVerification();
                    }
                }
            }
        )

    }
    saveEpisodeApi = (props, e) => {

        props.name = document.getElementById("name" + props.id).innerText.trim();
        props.relativeDuration = document.getElementById("when" + props.id).value;
        props.numberOfDays = document.getElementById("numberOfDays" + props.id).value;
        props.skillId = document.getElementById("skillId" + props.id).value;

        this.state.editedId = "-1";
        this.setState(this.state);
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        var addEpisodeController = this;
        if (props.name == "" || props.relativeDuration == "" || props.numberOfDays == "" || !props.skillId || props.skillId == "Select Intent Name") {
            addEpisodeController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(props.name)) {
            addEpisodeController.notifyImproperName();
        }
        else {
            var dataToSave = {
                name: props.name,
                numberOfDays: props.numberOfDays,
                relativeDuration: props.relativeDuration,
                skillId: props.skillId,
                patientId: localStorage.getItem('patientId'),
                patientAdmissionId: localStorage.getItem('patientAddmissionId'),
                addedByEmailId: this.userDetails.emailId,
                addedByName: this.userDetails.name,
            }
            $.ajax({
                url: "/my-jeeva-api/add-episode",

                method: 'POST',
                data: JSON.stringify(dataToSave),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },

                success: function (res) {
                    if (res.success === true) {
                        addEpisodeController.fetchEpisodeDataApi();
                        addEpisodeController.setState({ disableAddButton: false })
                    } else {
                        addEpisodeController.notifyFailedResponse(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            })
        }
    }

    notifyEpisodeAdded() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode added successfully</b>, {
            position: "top-center",
        });
    }

    notifyMsgFieldEmpty() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields</b>, {
            position: "top-center"
        }, { tosatId: "empty1" });

    }

    CustomNoDataComponent = () => (
        <div style={{ padding: '20px', textAlign: 'center' }}>
            <p>There is no agent episode scheduled.</p>
        </div>
    );

    notifyImproperName() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please provide a valid name</b>, {
            position: "top-center"
        });
    }
    notifyNoAgent() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;No Virtual agent for this treatment </b>, {
            position: "top-center"
        });
    }
    notifyFailedLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red",
        });
    }
    updateEpisodeApi = (props, e) => {

        props.name = document.getElementById("name" + props.id).innerText.trim();
        props.relativeDuration = document.getElementById("when" + props.id).value;
        props.numberOfDays = document.getElementById("numberOfDays" + props.id).value;
        props.skillId = document.getElementById("skillId" + props.id).value;
        var namePattern = new RegExp(/^(?!^[^A-Za-z0-9]+$)[A-Za-z0-9\s!@#$%^&*()-_=+{}\[\]|\\;:'",<.>/?]+$/);
        var saveData = {
            id: props.id,
            name: props.name,
            numberOfDays: props.numberOfDays,
            when: props.relativeDuration,
            skillId: props.skillId,
            patientAdmissionId: localStorage.getItem('patientAddmissionId'),
            patientId: localStorage.getItem('patientId')

        }
        var updateController = this;
        if (props.name == "" || props.relativeDuration == "" || props.numberOfDays == "" || props.skillId == null) {
            updateController.notifyMsgFieldEmpty();
        } else if (!namePattern.test(props.name)) {
            updateController.notifyImproperName();
        }
        else {
            $.ajax({
                url: "/my-jeeva-api/update-episode",

                method: 'PATCH',
                data: JSON.stringify(saveData),
                headers: {
                    'Authorization': "Bearer " + localStorage.getItem("access_token"),
                    'Content-Type': "application/json"
                },
                success: function (res) {
                    if (res.success === true) {
                        if (res.success === true) {
                            updateController.state.editedId = "-1";
                            updateController.fetchEpisodeDataApi();
                        } else {
                            updateController.notifyFailedResponse(res.result);
                        }
                    } else {

                        updateController.notifyFailedToUpdate(res.result);
                        updateController.state.disableAddButton = false;

                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/my-jeeva/login";
                    }
                }
            })
        }
    }


    notifuEpisodeUpdated() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
            content="" />&nbsp;&nbsp;Episode details updated successfully</b>, {
            position: "top-center",
        });
    }

    notifyFailedToUpdate(response) {
        toast.dismiss();
        toast(<b>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }



    makeCelledit(props, e) {
        this.markAsBeingEdited(props.id);
    }

    markAsBeingEdited(id) {
        this.state.editedId = id;
        var stateObj = this.state;
        this.setState(stateObj);
    }

    notifyError() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" />&nbsp;&nbsp;Oops! Error occurred.Please try again</b>, {
            position: "top-center"
        });
    }



    deleteEpisodeDetailApi = (id) => {
        let deleteRowViewController = this.state.loadedData;
        let deleteApiViewController = this;
        var deleteConstructorVariables = this;

        if (id == "") {
            deleteApiViewController.setState({ deleteRow: true });
            deleteConstructorVariables.setState({ hideDeletePopup: false });
            deleteConstructorVariables.setState({ hideDeleteSuccessPopup: true });
            deleteRowViewController.splice(id, 1);
        } else {
            $.ajax({
                url: "/my-jeeva-api/delete-episode/" + id,

                method: 'DELETE',
                headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
                success: function (res) {

                    if (res.success === true) {

                        deleteApiViewController.setState({ deleteRow: true });
                        deleteConstructorVariables.setState({ hideDeletePopup: false });
                        deleteRowViewController.splice(id, 1);
                        deleteConstructorVariables.state.loadedData = [];
                        deleteConstructorVariables.fetchEpisodeDataApi();
                    } else {
                        deleteRowViewController.notifyError();
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "";
                    }
                }
            });
        }

        if (this.state.deleteRow) {
            let data = [];
            this.setState({ loadedData: data });
        }
        let data = [];
        this.setState({ loadedData: data });
        deleteConstructorVariables.fetchEpisodeDataApi();
    }
    openDeletePopUp = (props) => {


        confirmAlert({
            title: 'Confirm to Delete',
            message: `Are you sure you want to delete ${props.name} ?`,
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => this.deleteEpisodeDetailApi(props.id)
                },
                {
                    label: 'No',
                }
            ],
            overlayClassName: "confirmAlertStyle"
        });
    }
    fetchEpisodeDataApi() {

        var fetchDataContoller = this;
        $.ajax({
            url: "/my-jeeva-api/episode",

            method: 'GET',
            data: {
                patientAdmissionId: localStorage.getItem('patientAddmissionId')
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    fetchDataContoller.state.showLoader = true;
                    fetchDataContoller.state.loadedData = res.result;
                    fetchDataContoller.state.disableAddButton = false;
                    fetchDataContoller.setState(fetchDataContoller.state);
                }


            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/my-jeeva/";
                }
            }
        });

    }


    refreshData = (e) => {
        // e.preventDefault();
        this.setState({
            disabled: false,
            editedId: "-1",
            loadedData: [],
        });
        this.fetchEpisodeDataApi();
    };


    notifyDelete() {
        toast.dismiss();
        toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Episode detail deleted successfully</b>, {
            position: "top-center",
        });
    }




    notifyFailedResponse(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"

        });
    }

    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    optionHandleChange = (props, e) => {
        props.name = document.getElementById("name" + props.id).innerText;
        props.relativeDuration = document.getElementById("when" + props.id).value;
        props.numberOfDays = document.getElementById("numberOfDays" + props.id).value;
        props.skillId = document.getElementById("skillId" + props.id).value;
        this.setState(this.state);
    }

    handleNameChange = (e, props) => {
        this.state.episodeName = e.currentTarget.textContent;
        e.target.selectionStart = 0
        e.target.selectionEnd = 0
        this.setState(this.state);
    };

    caseInsensitiveSort = (field) => (rowA, rowB) => {
        var a;
        var b;
        if (field === "numberOfDays") {
            a = rowA[field] ? rowA[field] : "";
            b = rowB[field] ? rowB[field] : "";

        } else {
            a = rowA[field] ? rowA[field].toLowerCase() : '';
            b = rowB[field] ? rowB[field].toLowerCase() : '';
        }
        if (a > b) {
            return 1;
        }

        if (b > a) {
            return -1;
        }

        return 0;
    };

    render() {
        const { loadedData } = this.state;
        const episode_column = [
            {
                name: <b>Name</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('name'),
                selector: (props) => (
                    <div name="name">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none',
                                paddingLeft: '2px', paddingTop: '6px', width: '98%',
                                border:
                                    (props.id == "" || props.id == this.state.editedId)
                                        ? '1px solid #D2D4DC'
                                        : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}
                            id={"name" + props.id}
                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{props.name}
                        </div>
                    </div>)
            },
            {
                name: <b>When</b>, sortable: true,
                sortFunction: this.caseInsensitiveSort('relativeDuration'),
                selector: (props) => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <div className="container-fluid" style={{ textAlign: "right" }}>
                            <select className="input-group form-control select2 "
                                onChange={(e) => this.optionHandleChange(props, e)}
                                value={props.relativeDuration} id={"when" + props.id}
                                style={{
                                    //  marginLeft: '-2vw',
                                    background: 'white', border: 'none',
                                    border: (props.id == undefined || props.id == this.state.editedId) ?
                                        '1px solid #D2D4DC' : 'none', borderRadius: (props.id == undefined) ? '2px' : 'none'
                                }}
                                disabled={(props.id == "") ? false : props.id != this.state.editedId}
                            >
                                {this.loadedWhenInfo.map(whenInfo => (
                                    <option key={whenInfo} value={whenInfo['name']} >
                                        {whenInfo['name']}
                                    </option>

                                ))}
                                <option hidden value='Select When'>Select When</option>

                            </select>
                        </div>

                    </div>)
            }, {
                name: <b>No. of Days</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('numberOfDays'),
                selector: (props) => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <div className="container-fluid" style={{ textAlign: "right" }}>
                            <select className="input-group form-control select2 "
                                onChange={(e) => this.optionHandleChange(props, e)}
                                value={props.numberOfDays} id={"numberOfDays" + props.id}
                                style={{
                                    background: 'white', border: 'none',
                                    border: (props.id == undefined || props.id == this.state.editedId) ?
                                        '1px solid #D2D4DC' : 'none', borderRadius: (props.id == undefined) ? '2px' : 'none'
                                }}
                                disabled={(props.id == "") ? false : props.id != this.state.editedId}
                            >
                                {this.loadedNumberOfDaysInfo.map(numberOfDaysInfo => (
                                    <option key={numberOfDaysInfo} >
                                        {numberOfDaysInfo}
                                    </option>

                                ))}
                                <option hidden value='Select Number Of Days'>Select Number Of Days</option>

                            </select>
                        </div>

                    </div>)
            },
            {
                name: <b>Intent</b>,
                sortable: true,
                sortFunction: this.caseInsensitiveSort('intentName'),
                selector: (props) => (
                    <div className="container-fluid" style={{ textAlign: "right" }}>
                        <div className="textarea"
                            style={{
                                display: (props.id == "" || props.id == this.state.editedId) ? 'none' : 'block',
                                background: 'white', height: "2.7em", resize: 'none', textAlign: "center", overflow: "hidden",
                                paddingLeft: '2px', paddingTop: '6px', width: '100%', fontSize: '15px', borderRight: '1px solid rgb(189, 186, 194 )',
                                border: (props.id == "" || props.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                                borderRadius: (props.id == "") ? '2px' : 'none'
                            }}

                            contentEditable={!((props.id == "") ? false :
                                props.id != this.state.editedId) ? "plaintext-only" : false}
                        >{this.intentMap[props.skillId]}
                        </div>
                        <select className="input-group form-control select2 "
                            onChange={(e) => this.optionHandleChange(props, e)}
                            value={props.skillId} id={"skillId" + props.id}
                            style={{
                                display: (props.id == "" || props.id == this.state.editedId) ? 'block' : 'none',
                                background: 'white', border: 'none',
                                border: (props.id == undefined || props.id == this.state.editedId) ?
                                    '1px solid #D2D4DC' : 'none', borderRadius: (props.id == undefined) ? '2px' : 'none'
                            }}
                            disabled={(props.id == "") ? false : props.id != this.state.editedId}
                        >
                            {this.loadedAgentSkills.map(loadedAgentSkill => (
                                <option key={loadedAgentSkill.id} value={loadedAgentSkill.id} >
                                    {loadedAgentSkill.description}
                                </option>

                            ))}
                            <option hidden value='Select Intent Name'>Select Intent Name</option>

                        </select>
                    </div>)
            },
            {
                name: <b>Actions</b>,
                width: 200,
                selector: (props) => (
                    <div id="action">
                        <button style={{ backgroundColor: "#ffffff", border: "none", marginLeft: '-6px' }} >
                            <img className="img-responsive"
                                title={(props.id == "") ||
                                    (props.id == this.state.editedId) ? 'Save' : 'Edit'}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                src={(props.id == "") ? this.saveImageSrc : ((props.id != this.state.editedId) ? this.editImageSrc : this.saveImageSrc)}
                                onClick={(e) => {
                                    (props.id == "") ? this.saveEpisodeApi(props, e) : (props.id == this.state.editedId) ?
                                        this.updateEpisodeApi(props, e) : this.makeCelledit(props, e);
                                }} />
                        </button>


                        <button style={{
                            backgroundColor: "#ffffff", border: "none", marginLeft: '-6px'
                        }} title="Delete">
                            <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                                style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px' }}
                                onClick={() => (props.id) === '' ?
                                    this.fetchEpisodeDataApi() :
                                    this.openDeletePopUp(props)}

                            /></button>
                    </div>), width: 100
            },
        ]
        return (
            <div style={{ marginRight: '1%' }} id='painDataTab'>

                <div style={{ background: "#F9F9FB", overflowY: 'scroll', overflowX: 'hidden', height: '60vh' }} >
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link href="assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="assets/css/screenResolution.css" rel="stylesheet" />
                    <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                    <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                    <link rel="stylesheet" href="assets/css/adminlte.css" />
                    <link rel="stylesheet" href="assets/css/custom-style.css" />
                    <link rel="stylesheet" href="assets/css/styles.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />
                    <link rel="stylesheet" href="assets/css/painDataSchedule.css" />


                    <div className="row" style={{ marginLeft: '14px' }}>
                        <div className='col-sm-1'>
                            <h6 className="nav-item" style={{ color: '#282a65', marginTop: '1vh' }}>
                                Episode</h6>
                        </div>
                        <div className='col-sm-8' Align='right'>

                        </div>
                        <div className="col-sm-3" style={{ marginTop: '-18px' }}>
                            <div className="d-flex flex-row-reverse pt-2">

                                <div className="p-2" style={{ marginBottom: '10px' }}>

                                    <button className="btn action-button"
                                        id="addMsg" title=" Add "
                                        onClick={this.state.disableAddButton ? this.notifyMsgFieldEmpty : this.addEmptyRow}>
                                        <img src="assets/images/add_white_24dp.png" />
                                    </button>
                                    <button title="Refresh" onClick={this.refreshData} type="button" className="btn action-button">
                                        <img src="./assets/images/refresh_white_24dp.png"></img></button>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ textAlign: 'left' }}>
                        <div className="col-lg-12 ">
                            <div className="card">
                                <DataTable
                                    data={loadedData}
                                    columns={episode_column}
                                    defaultPageSize={5}
                                    pageSizeOptions={[5, 10, 15]}
                                    onPageChange={this.onPageChange}
                                    pagination={this.state.paginationValue}
                                    noDataComponent={<this.CustomNoDataComponent />}
                                />
                            </div>
                            {/* <ToastContainer className="Toast-at-center" /> */}
                        </div>
                    </div>
                </div>
            </div >
        )
    }
}

export default PainDataSchedule;


// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/PainDataSchedule.js